import { chakra, HStack } from '@chakra-ui/react';
import { KeyCap } from '@/components/ui/ShortcutHint';

interface ShortcutTooltipProps {
	/** What pressing it does, named as the pass's own verb rather than as the button's label. */
	action: string;
	shortcutKey: string;
}

/**
 * A verdict's tooltip: what it does, and the key that does it.
 *
 * Says "Keep task" over a button reading "Keep unscheduled" — a tooltip that repeats the words
 * already under the pointer is a tooltip nobody reads twice, and the object the verb takes is the
 * useful half a one-word button label leaves out.
 *
 * Its own component because three verdicts want the same shape, and a keycap sitting beside text
 * needs the flex row `ShortcutHint` documents: a 16px cap in a 12px line has no vertical alignment
 * that reads right.
 */
const ShortcutTooltip = ({ action, shortcutKey }: ShortcutTooltipProps) => (
	<HStack gap={1.5}>
		<chakra.span>{action}</chakra.span>
		{/* Decorative: the button declares the key through `aria-keyshortcuts`, and a cap inside the
		    accessible name is read out as part of the label. */}
		<KeyCap decorative>{shortcutKey}</KeyCap>
	</HStack>
);

export default ShortcutTooltip;
